export default "__VITE_ASSET__axf$74ws__"